import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-loading",
  templateUrl: "./loading.component.html",
  host: {
    class: "dbc1-loading-host",
  },
  standalone: false,
})
export class LoadingComponent implements OnInit {
  @Input() text?;
  @Input() hideText?;

  constructor() {}

  ngOnInit(): void {}
}
